import { Badge, Button, ClockIcon, RotateCcwIcon } from '@fukuri-admins/ui/common';
import styles from './styles.module.scss';

type Props = {
  isScheduleSet: boolean;
  onClickSetSchedule: () => void;
  onClickReset: () => void;
  onClickEdit: () => void;
};

export const StressAssessmentScheduleAlertPresentation: React.FC<Props> = ({
  isScheduleSet,
  onClickSetSchedule,
  onClickReset,
  onClickEdit,
}) => {
  if (isScheduleSet) {
    return (
      <div className={styles.containerSet}>
        <div className={styles.body}>
          <ClockIcon size='md' className={styles.clockIcon} />
          <div className={styles.textGroup}>
            <div className={styles.titleRow}>
              <p className={styles.title}>スケジュールの設定</p>
              <Badge status='success' variant='subtle' size='sm' label='リマインドON' />
            </div>
            <p className={styles.description}>
              実施月の前月と当月の1日に管理者宛にリマインド通知を送信します。
            </p>
          </div>
        </div>
        <div className={styles.actions}>
          <Button
            variant='ghost'
            size='sm'
            icon={<RotateCcwIcon size='xs' />}
            iconPosition='left'
            onClick={onClickReset}
          >
            設定をリセット
          </Button>
          <Button variant='outline' size='sm' onClick={onClickEdit}>
            編集
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.body}>
        <div className={styles.icon}>
          <ClockIcon size='md' />
        </div>
        <div className={styles.textGroup}>
          <p className={styles.title}>スケジュールの設定</p>
          <p className={styles.description}>
            ストレスチェックを実施する月を設定すると、実施月の前月と当月の1日に管理者宛にリマインド通知を送信します。
          </p>
        </div>
      </div>
      <div className={styles.actions}>
        <Button variant='outline' size='sm' onClick={onClickSetSchedule}>
          実施月を設定
        </Button>
      </div>
    </div>
  );
};
